import { ProgressLinear } from '@itwin/itwinui-react';
import React from 'react';
import { useThemeContext } from '../../context/themeContext';
import { themedText } from '../../styles/SharedStyles';
import './LoadingPage.scss';

export interface LoadingPageProps {
  fullscreen?: boolean;
  text?: string;
  subtext?: string;
  value?: number;
  className?: string;
}

export function LoadingPage({
  fullscreen = false,
  text = 'Loading',
  subtext,
  value,
  className,
}: LoadingPageProps): JSX.Element {
  const theme = useThemeContext();
  const indeterminate = value === undefined;

  const loadingPageClassList = (): string => {
    const classes = ['teams-loading-page'];

    if (className) {
      classes.push(className);
    }

    if (fullscreen) {
      classes.push('teams-loading-page-fullscreen');
    }

    return classes.join(' ');
  };

  return (
    <div className={loadingPageClassList()} style={{ ...themedText(theme) }}>
      <div className='teams-loading-container'>
        <div className='teams-loading-text'>{text}</div>
        <ProgressLinear
          labels={[subtext, '']}
          indeterminate={indeterminate}
          value={value}
        />
      </div>
    </div>
  );
}
